
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editions/[id]",
      function () {
        return require("private-next-pages/editions/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editions/[id]"])
      });
    }
  